/* 🤖 this file was generated by svg-to-ts */
export const matIconBoy: {
  name: 'boy';
  data: string;
} = {
  name: 'boy',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M12 7.5c.97 0 1.75-.78 1.75-1.75S12.97 4 12 4s-1.75.78-1.75 1.75S11.03 7.5 12 7.5zM14 20v-5h1v-4.5c0-1.1-.9-2-2-2h-2c-1.1 0-2 .9-2 2V15h1v5h4z"/></svg>`
};
